import SearchIcon from '@ixigo/icons/Search';
import Input from '@ixigo/iui/Input';
import type { SearchInputProps } from './types';

const SearchInput = ({ value, onChange, className = '', placeholder = '' }: SearchInputProps) => {
	return (
		<div className={className}>
			<Input
				fullWidth
				placeholder={placeholder}
				variant="outlined"
				type="search"
				onChange={onChange}
				value={value}
				endAdornment={!value ? <SearchIcon /> : ''}
			/>
		</div>
	);
};

export default SearchInput;
